<script lang="ts">
  import Modal from "./Modal.svelte";
  import { api } from "$lib/api/client";
  import { privacy } from "$lib/stores/privacy.svelte";
  import { toasts } from "$lib/stores/toasts.svelte";

  let { open = $bindable(false), onUnlock } = $props<{
    open?: boolean;
    onUnlock?: () => void;
  }>();

  let pin = $state("");
  let busy = $state(false);
  let error = $state<string | null>(null);

  async function submit(e: SubmitEvent) {
    e.preventDefault();
    if (!/^\d{4,8}$/.test(pin)) {
      error = "PIN deve ter 4 a 8 dígitos.";
      return;
    }
    busy = true;
    error = null;
    try {
      await api("/me/privacy-pin/verify", {
        method: "POST",
        body: JSON.stringify({ pin }),
      });
      privacy.unlock();
      pin = "";
      open = false;
      onUnlock?.();
      toasts.success("Camada privada desbloqueada.");
    } catch (e: any) {
      if (e?.status === 400) error = "Defina um PIN nas configurações primeiro.";
      else if (e?.status === 403) error = "PIN incorreto.";
      else error = "Falha ao verificar PIN.";
    } finally {
      busy = false;
    }
  }

  function close() {
    open = false;
    pin = "";
    error = null;
  }
</script>

<Modal bind:open title="Desbloquear camada privada" onClose={close}>
  <form onsubmit={submit} class="space-y-3">
    <p class="text-sm text-zinc-600 dark:text-zinc-400">
      Digite seu PIN para visualizar transações marcadas como privadas. A camada
      relock após 5 minutos sem atividade.
    </p>
    <input
      type="text"
      inputmode="numeric"
      pattern="[0-9]*"
      autocomplete="new-password"
      maxlength="8"
      class="input w-full text-center tracking-[0.5em] text-lg"
      placeholder="••••"
      style="-webkit-text-security: disc;"
      bind:value={pin}
      disabled={busy}
      oninput={(e) => { pin = (e.currentTarget as HTMLInputElement).value.replace(/\D/g, ""); }}
    />
    {#if error}
      <p class="text-sm text-red-600 dark:text-red-400">{error}</p>
    {/if}
    <div class="flex justify-end gap-2 pt-1">
      <button type="button" class="btn-ghost" onclick={close} disabled={busy}>Cancelar</button>
      <button type="submit" class="btn-primary" disabled={busy || pin.length < 4}>
        {busy ? "Verificando…" : "Desbloquear"}
      </button>
    </div>
  </form>
</Modal>
